import {Issue} from "../api/issue.ts";
import {FC} from "react";
import Panel from "../atoms/Panel.tsx";
import {Column, Row} from "../atoms/Layout.tsx";
import {Text} from "../style/typography.tsx";
import {ArrowRightIcon} from "../atoms/Icon";
import PriorityCircle from "../atoms/PriorityCircle.tsx";
import { DateTime } from "luxon";
import {useNavigate} from "react-router";
import {useSite} from "../store/siteContext.ts";

interface Props {
    issue: Issue
}

const formatDate = (ms: number): string => {
    const dt  = DateTime.fromMillis(ms);
    const now = DateTime.local();

    return dt.hasSame(now, 'day')
        ? `Today ${dt.toFormat('HH:mm')}`
        :       dt.toFormat('ccc dd LLL HH:mm');
}

const IssueListItem: FC<Props> = ({ issue }) => {
    const site = useSite();
    const navigate = useNavigate();

    return <Panel onClick={() => navigate(`/u/dashboard/site/${site.id}/issue/${issue.id}/details`)}>
        <Row gap="8" centerVertically>
            <PriorityCircle priority={issue.priority} />
            <Column grow gap="4">
                <Text role="body" size="2" weight="medium">{issue.title}</Text>
                <Text role="body" size="4" weight="regular">{formatDate(issue.createdAt)}</Text>
            </Column>
            <ArrowRightIcon size={16} />
        </Row>
    </Panel>
}

export default IssueListItem;